import { gql } from 'graphql-request'

export const EXPORT_STORY_DETAIL_DASHBOARD = gql`
  query ExportStoryDetailDashboard(
    $startDate: DateTime!
    $endDate: DateTime!
    $bookId: Int!
  ) {
    exportStoryDetailDashboard(
      startDate: $startDate
      endDate: $endDate
      bookId: $bookId
    )
  }
`
